export default {
  it: {
    menu: {
      products: 'Prodotti',
      services: 'Perché Glaxi Pane',
      academy: 'Academy',
      quality: 'Qualità',
      company: 'Azienda',
      contacts: 'Contatti'
    },
    labelMenu: {
      tab01: 'tutti',
      tab02: 'novità',
      tab03: 'specialità',
      back: 'Indietro',
      searchResults: 'nessun risultato trovato | 1 risultato trovato | {count} risultati trovati',
      searchExample01: 'Cosa stai cercando?',
      searchExample02: "es: Hamburger",
      searchExample03: "es: Tramezzino"
    },
    home: {
      desc1Title: 'Il pane è di casa',
      desc1Desc: "Panificatori fin dagli anni '50, abbiamo unito<br> in un perfetto equilibrio le sapienti tradizioni familiari<br> alle più avanzate tecnologie produttive,<br> offrendo la risposta più efficace<br> alla distribuzione moderna.",
      overlineTitle: 'Prodotti novità',
      desc2Title: 'Tramezzini, sandwich, hamburger,<br> schiacciate, ciabatte, baguette....',
      desc2Desc: 'Dal bancone del bar al tavolo del ristorante,<br> l’ampia gamma di panificati Glaxi<br> copre ogni esigenza di committenza e consumatore.',
      textImageTitle: 'Galante:<br> panificatori<br> da tre<br> generazioni',
      textImageDescription: "Panificatori fin dagli anni '50,  abbiamo unito in un perfetto equilibrio le sapienti tradizioni familiari.",
      textImageTextButton: 'la famiglia Glaxi',
      textParallaxTitle: 'No additivi',
      textParallaxTitle2: 'No conservanti',
      textParallaxTitle3: 'No OGM',
      textParallaxTextButton: 'la surgelazione'
    },
    services: {
      howItWorks: 'Come funziona',
      discover: 'Scopri l’assortimento Glaxi',
      wishlist: 'Inserisci i prodotti a cui sei<br> interessato nella tua wishlist',
      getQuote: 'Richiedi informazioni senza<br> impegno al nostro agente',
      discover2: 'Scopri l’assortimento',
      fidelity: 'Si affidano a noi'
    },
    company: {
      smallIntro: 'Passione per il pane',
    },
    academy: {
      tab01: 'Tutto',
      tab02: 'Ricette',
      tab03: 'Live from',
      tab04: 'Tips&Tricks',
      blockTitle: 'Glaxi<br/> Academy',
      blockSubtitle: 'libera l’ispirazione',
      loadMore: 'Mostra Altri',
      chefText: 'Chef ed esperto per la scelta degli alimenti. E’ stato responsabile vendita di In.Gredienti (Fam.Alajmo).  Annovera centinaia di collaborazioni in tutta Europa ed in Italia presso Hotel Cristallo di Cortina d’Ampezzo, Il Mascherone e Roscioli di Roma.<br/> Chef presso Antenore Km 0 di Padova, startup la Bodega di Villach. Chef testimonial del “Lo Spettacolo del Cuore”. Chef nelle dimostrazioni di Glaxi Pane.'
    },
    common: {
      discover: 'scopri',
      references: '0 referenze | 1 referenza | {count} referenze',
      shareArticle: 'Condividi l\'articolo',
      isNew: 'Novità',
      yes: 'Si',
      no: 'No',
      and: 'e',
      newProduct: 'Prodotto novità'
    },
    tabs: {
      formatProducts: 'Con questo formato',
      similarProducts: 'Prodotti Simili',
      sameIngredientProducts: 'Con la stessa farina'
    },
    internalNextPages: {
      servicesTitle: 'perché<br>Glaxi Pane',
      servicesContent: 'È una domanda che ti suggeriamo<br> di farti. Siamo felici di darti una<br> risposta. Anzi più di una.',
      servicesLink: 'Scopri perché Glaxi Pane',
      qualityTitle: 'Qualità',
      qualityContent: 'Grazie ai principi fondamentali<br> che guidano ogni giorno il<br> nostro lavoro.',
      qualityLink: 'Scopri la qualità Glaxi Pane',
      companyTitle: 'L’azienda',
      companyContent: 'Una storia d’amore con il<br> pane che dura da una vita.',
      companyLink: 'Scopri l\'azienda Glaxi Pane'
    },
    wishlist: {
      addToList: 'Aggiungi alla lista',
      yourCart: 'Benvenuto<br> nel tuo paniere.',
      cartMessage: 'Verifica i prodotti nel paniere ed invia una richiesta senza impegno.',
      cartMessage2: 'Qui puoi salvare i prodotti a cui sei interessato e richiedere maggiori informazioni in ogni momento.<br><br> Consulta i prodotti, scegli quelli desiderati e inizia subito a riempire il tuo paniere!',
      remove: 'Rimuovi',
      next: 'Prosegui',
      dataInsert: 'Inserisci i tuoi dati',
      yourData: 'Lasciaci i tuoi dati per permetterci di<br> rispondere alla tua richiesta.',
      alreadyCustomer: 'Sei già un nostro cliente?',
      moreInformations: 'Vuoi maggiori informazioni su',
      putInBox: 'metti nel paniere e invia richiesta'
    },
    notFound: {
      title: '404. Pagina non trovata.',
      description: 'Non siamo riusciti a trovare la pagina che cercavi.',
      allow: 'Acconsento',
      notAllot: 'Non Acconsento'
    },
    cookieBar: {
      title: 'Possiamo utilizzare i tuoi dati per migliorare il sito?',
      text: 'Questo sito utilizza cookie a fini tecnici, statistici e per offrire annunci pubblicitari focalizzati sui tuoi interessi. Cliccando acconsento, autorizzi l’utilizzo di tali cookies. Per ulteriori informazioni consulta la nostra'
    },
    forms: {
      name: 'Nome',
      surname: 'Cognome',
      profession: 'Professione',
      stockist: 'Grossista',
      transformer: 'Trasformatore',
      barman_restaurateur: 'Barista/Ristoratore',
      other: 'Altro',
      company: 'Ragione sociale',
      city: 'Città',
      province: 'Provincia',
      email: 'Email',
      emailAddress: 'indirizzo email',
      telephone: 'Telefono',
      message: 'Messaggio',
      articles: 'Ai sensi e per gli effetti degli artt. 7, 12, 13 ss. del Reg. UE 2016/679 - GDPR:',
      privacyText01: 'dichiaro di aver preso visione della',
      privacyText02: 'per il trattamento dei miei dati personali;',
      privacyText03: 'acconsento al trattamento dei miei dati personali per ricevere comunicazioni promozionali / commerciali.',
      privacyText04: 'Avvertenza: verranno prese in considerazione solamente le richieste provenienti da esercizi commerciali.',
      privacyTextFormNewsletter: 'acconsento al trattamento dei miei dati personali per ricevere Newsletter come da',
      send: 'Invia richiesta',
      successTitle: 'Grazie per averci contattato,<br> abbiamo ricevuto la tua richiesta.',
      successText: 'Ti contatteremo a breve.',
      failureTitle: "Si è verificato un problema<br> durante l'invio del modulo.",
      failureText: 'Contattaci direttamente presso <a href="mailto:info@glaxipane.com">info@glaxipane.com</a>.',
      stayTuned: 'rimani aggiornato<br> con le novità glaxi',
      newsletterText: 'acconsento al trattamento dei miei dati personali per ricevere Newsletter come da',
      subscribe: 'Iscriviti'
    }
  },
  en: {
    menu: {
      products: 'Products',
      services: 'Why Glaxi Pane',
      academy: 'Academy',
      quality: 'Quality',
      company: 'Company',
      contacts: 'Contacts'
    },
    labelMenu: {
      tab01: 'all',
      tab02: 'new',
      tab03: 'specialities',
      back: 'Back',
      searchResults: 'No results found | 1 result found | {count} results found',
      searchExample01: 'What are you looking for?',
      searchExample02: "e.g.: Hamburger bun",
      searchExample03: "e.g.: Tramezzino"
    },
    home: {
      desc1Title: 'Bread is at home here',
      desc1Desc: "Bakers since the 1950s, we have joined<br> in perfect harmony the skilfulness of family traditions<br> with the most advanced production technologies,<br> offering modern distribution the best<br> and most effective responses.",
      overlineTitle: 'New products',
      desc2Title: 'Tramezzini, sandwiches, hamburger buns,<br> flatbread, ciabatta, baguettes...',
      desc2Desc: 'From the bar to the table in the restaurant,<br> the wide range of Glaxi bread products<br> covers all of the clients\' and consumers\' needs.',
      textImageTitle: 'Galante:<br> three<br> generations<br> of bakers',
      textImageDescription: "Bakers since the 1950s, we have found the perfect equilibrium of the skilfulness of family traditions.",
      textImageTextButton: 'the Glaxi family',
      textParallaxTitle: 'No additives',
      textParallaxTitle2: 'No preservatives',
      textParallaxTitle3: 'No GMOs',
      textParallaxTextButton: 'freezing'
    },
    services: {
      howItWorks: 'How it works',
      discover: 'Discover the Glaxi assortment',
      wishlist: 'Enter the products<br> that interest you in your wishlist',
      getQuote: 'Request information,<br> without commitment,<br> to our agent',
      discover2: 'Discover the assortment',
      fidelity: 'Relying on us'
    },
    company: {
      smallIntro: 'Passion for bread',
    },
    academy: {
      tab01: 'All',
      tab02: 'Recipes',
      tab03: 'Live from',
      tab04: 'Tips&Tricks',
      blockTitle: 'Glaxi<br/> Academy',
      blockSubtitle: 'free inspiration',
      loadMore: 'Show More',
      chefText: 'Chefs and experts in the choice of food. He was the sales manager of In.Gredienti (Alajmo Family). There are hundreds of partnerships throughout Europe and in Italy at Hotel Cristallo of Cortina d\'Ampezzo, il Mascherone and Roscioli of Rome. Chef at Antenore Km 0 of Padua, startup la Bodega of Villach. Chef testimonial of "Lo Spettacolo del Cuore". Chef in the demonstrations of Glaxi Pane.'
    },
    common: {
      discover: 'learn more',
      references: '0 references | 1 reference | {count} references',
      shareArticle: 'Share the article',
      isNew: 'New',
      yes: 'Yes',
      no: 'No',
      and: 'and',
      newProduct: 'Product news'
    },
    tabs: {
      formatProducts: 'With this format',
      similarProducts: 'Similar Products',
      sameIngredientProducts: 'With the same flour'
    },
    internalNextPages: {
      servicesTitle: 'why<br>Glaxi Pane',
      servicesContent: 'It\'s a question we suggest you<br> ask yourself. We\'re happy to give you<br> an answer. Actually, more than one.',
      servicesLink: 'Discover why Glaxi Pane',
      qualityTitle: 'Quality',
      qualityContent: 'Thanks to the fundamental<br> principles that guide our work<br> each and every day.',
      qualityLink: 'Discover the quality of Glaxi Pane',
      companyTitle: 'Our company',
      companyContent: 'A love story with bread<br> that lasts a lifetime.',
      companyLink: 'Discover the company Glaxi Pane'
    },
    wishlist: {
      addToList: 'Add to the list',
      yourCart: 'Welcome to your basket.',
      cartMessage: 'Check the products in the basket and send a request, without obligation.',
      cartMessage2: 'Here you can save the products you are interested in and request more information at any time.<br><br> Check out the products, choose the ones you want and start filling your basket!',
      remove: 'Remove',
      next: 'Next',
      dataInsert: 'Enter your details',
      yourData: 'Leave your contact information so that<br> we can respond to your request.',
      alreadyCustomer: 'Already our customer?',
      moreInformations: 'Do you want more informations about',
      putInBox: 'put in the basket and send request'
    },
    notFound: {
      title: '404. Page not found.',
      description: 'We weren\'t able to find the page you were looking for.',
      allow: 'I agree',
      notAllot: 'I do not agree'
    },
    cookieBar: {
      title: 'May we use your information to improve the site?',
      text: 'This site uses cookies for technical and statistical purposes, as well as for offering advertisement specific to your interests. By clicking agree, you authorise the use of such cookies.<br> For more information please visit our'
    },
    forms: {
      name: 'Name',
      surname: 'Surname',
      profession: 'Profession',
      stockist: 'Stockist',
      transformer: 'Transformer',
      barman_restaurateur: 'Barman/Restaurateur',
      other: 'Other',
      company: 'Company',
      city: 'City',
      province: 'Country',
      email: 'Email',
      emailAddress: 'email address',
      telephone: 'Telephone',
      message: 'Message',
      articles: 'Pursuant to and for the purposes of Articles 7, 13 and 15 of Regulation EU 2016/679 - GDPR:',
      privacyText01: 'I agree to the processing of my personal data as the',
      privacyText02: 'describes;',
      privacyText03: 'I agree to the processing of my personal data to receive promotional / commercial communications.',
      privacyText04: 'Warning: only requests from businesses will be considered.',
      privacyTextFormNewsletter: 'I agree to the processing of my personal data to receive promotional / commercial communications as described in the',
      send: 'Send request',
      successTitle: 'Thanks for contacting us<br/> we received your request.',
      successText: 'We have taken in charge your request for information,<br/> we will contact you as soon as possible.',
      failureTitle: "There was an error<br/> trying to send your message.",
      failureText: 'Contact us to <a href="mailto:info@glaxipane.com">info@glaxipane.com</a>.',
      stayTuned: 'keep up to date with<br> the new glaxi products',
      newsletterText: 'I agree to receive updates throw Glaxi Pane newsletter as described in the',
      subscribe: 'Subscribe'
    }
  }
}
